<template>
  <div class="page border-box" v-wechat-title="'太史图'">
    <!--<swiper v-if='list.length>0' :options="swiperOption" ref="mySwiper">-->
      <!--<div v-for="(item,index) in list" :key="index" class="swiper-slide">-->
        <!--<img :src="item.allimg" alt="">-->
      <!--</div>-->
    <!--</swiper>-->
    <div class="swiper-container" id="mySwiper"  v-if="list && list.length>0">
      <div class="swiper-wrapper">

        <div class="swiper-slide full-slide slide1" data-ind="0">
          <!--<img class="tst-text" src="../../assets/tst/text.png" alt="">-->
          <!--<img class="footer-logo" src="../../assets/tst/footer-logo.png" alt="">-->
          <img src="../../assets/tst/index-logo.png" alt="" class="index-logo">
        </div>
        <div class="swiper-slide full-slide slide2 border-box" data-ind="1">
          <div class="txt-con">
            <p class="tit">【引】</p>
            <div class="txt">司马迁撰写的《史记》是中国第一部纪传体通史，记载了自上古黄帝时代到汉武帝太初年间共三千多年中国历史。《史记》最初或称“太史公书”，“史记”二字本为中国古代史书的通称，三国时期开始成为“太史公书”的专称。《中华源流·太史图》以本书著者向  吉德创作的历史长赋《中华颂》为统揽，通过国画工笔连环画长卷艺术手法，全景展现勤劳、智慧、勇敢的英雄先祖群像，让读者走进历史“大观园”，打开中华民族生生不息的源流画卷。全赋分五章：第一章《中华颂·太史前图》以混沌初开到《史记》开篇为时间线，引出“中华文明创世图·洪荒时代大观园”并叙说本书缘起；第二章《中华颂·太史上图》以黄帝降世到大禹立夏为时间线，展示“三皇五帝源流图·中华始祖大观园”；第三章《中华颂·太史中图》以夏商周代到战国末年为时间线，展示“问鼎中原逐鹿图·诸侯时代大观园”；第四章《中华颂·太史下图》以秦国一统到汉太初年为时间线，展示“秦汉万里开疆图·英雄时代大观园”；第五章《中华颂·太史后图》以《史记》收篇到进入新时代为时间线，展示“薪火相继奋进图·复兴时代大观园”。其中《太史上图》《太史中图》《太史下图》完全按照《史记》内容编创，是一部国史方志和家乘谱系并行阐发、交融呈现的“家国史录”；是一部高度凝练、贯古及今的“中华历史文脉图鉴”；是一部“看得见的中华历史”、“走得进的英雄传奇”！是中国历史“最中国”的打开方式。</div>
          </div>
        </div>
      <!--<div class="swiper-slide full-slide slide3 border-box" data-ind="2">-->
        <!--<img class="logo" src="../../assets/tst/logo.png" alt="">-->
        <!--<img class="tit-img t1" src="../../assets/tst/tit1.png" alt="" @click="toStep(4)">-->
        <!--<img class="tit-img t2" src="../../assets/tst/tit2-curr.png" alt="" @click="toStep(5)">-->
        <!--<img class="tit-img t3" src="../../assets/tst/tit3.png" alt="" @click="toStep(6)">-->
        <!--<img class="tit-img t4" src="../../assets/tst/tit4.png" alt="" @click="toStep(7)">-->
        <!--<img class="tit-img t5" src="../../assets/tst/tit5.png" alt="" @click="toStep(8)">-->
      <!--</div>-->
        <div class="swiper-slide full-slide slide4" data-ind="3">
        <img class="title-bg" src="../../assets/tst/title-bg.png" alt="">
        <!--<p class="num tc">贰</p>-->
        <!--<p class="t1">太史上图</p>-->
        <!--<p class="t2">三皇五帝源流图 · 中华始祖大观园</p>-->
      </div>
        <div class="swiper-slide" :data-ind="index+3" v-for="(item,index) in list" :key="item.id">
        <!--<img class="img" v-lazy="((swiperInd==index+3)||(audioInd==index))?item.logo:item.allimg" alt="">-->
        <img class="img" :src="((swiperInd==index+3)||(audioInd==index))?item.logo:item.allimg" alt="">
        <div class="story-btn btn1" @click="storyAudioPlay(index)">
          <div class="t">
            <img src="../../assets/tst/audio-curr.gif" alt="" v-if="playingInd==index">
            <img src="../../assets/tst/audio.png" alt="" v-else>
          </div>
          <p class="b">语音讲解</p>
        </div>
        <div class="story-btn btn2" @click="storyDetailShow(index)">
          <div class="t">
            <img src="../../assets/tst/story-btn.png" alt="">
          </div>
          <p class="b">图文故事</p>
        </div>
      </div>
        <div class="swiper-scrollbar" slot="scrollbar"></div>
      </div>
    </div>

    <!--故事详情弹窗-->
    <div class="story-alert" :class="alertShow==1?'curr':''" v-if="alertShow==1">
      <div class="con">
        <p class="tit">{{list[storyInd].spotname}}</p>
        <div class="txt" v-html="list[storyInd].sub"></div>
        <img src="../../assets/tst/close-btn.png" alt="" @click="alertShow=0">
      </div>
    </div>

    <!--<div class="tip-box" v-if="screenTipShow==1">-->
      <!--<img src="../../assets/tst/tip-bg.png" alt="" class="icon">-->
      <!--<p>为了更好的体验，请使用横屏浏览</p>-->
    <!--</div>-->

    <audio id="AudioStory" style="overflow: hidden" :hidden="true" controls autoplay="autoplay" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

  </div>


</template>

<script>
  import axios from 'axios'
  import { Swiper, swiperSlide } from 'vue-awesome-swiper'
  import 'swiper/dist/css/swiper.css'
  import {getVideoPlay,} from "@/service/getData";
  import {getServer} from '@/utils/share'
  import Qs from 'qs'
  import {} from "@/service/getData";
  import {wxShareme} from '@/utils/wechat'
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import wxConfirm from '@/wechat-messagebox/Confirm'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)
  export default {
    data(){
      return {
        userInfo: {}, //用户信息
        loadEnd: false, //数据加载结束则赋值为true
        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        id: '', //专辑id
        spotid: '', //景点id
        shopid: '', //景区id
        loadingShow:0,//是否显示loading层
        alertShow:0,//是否显示故事详情
        screenTipShow:0,//是否显示横屏提示
        list:[
          {
            "sub":"<p>太史公曰：</p><p>黄帝者，少典之子，姓公孙，名曰轩辕……——《史记·五帝本纪》</p><p><br/></p><p>中华历史源流素以女娲造人、盘古开天神话传说起始，司马迁所著纪传体《史记》则从五帝中的黄帝开始记述。上古时代，当时生活在姬水一带的有熊氏部落，其首领为少典，他同有蟜氏女在姬水边生下一个儿子，便是黄帝。黄帝后来居于轩辕之丘，所以名叫轩辕，这就是中华民族的人文初祖。</p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306743,
            "allimg":require("../../assets/tst/tst2-01.jpg"),
            "hotLevel":0,
            "spotname":"史记初录  五帝开篇   少典姬授  兹生轩辕",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211119/7b9cc9c5a4379c743ffe3db49bbf88bc.mp3",
            "number":0,
            "totaltime":134,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-01-1.gif"),
            "id":66014,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>生而神灵，弱而能言，幼而徇齐，长而敦敏，成而聪明。轩辕之时，神农氏世衰。诸侯相侵伐，暴虐百姓，而神农氏弗能征。于是轩辕乃习用干戈，以征不享，诸侯咸来宾从……东至于海，登丸山，及岱宗。西至于空桐，登鸡头。南至于江，登熊、湘。北逐荤粥，合符釜山，而邑于涿鹿之阿……——《史记·五帝本纪》</p><p><br/></p><p>相传轩辕一生下来就会说话，稍长后，英明神武，智谋超人，深受拥戴。当时神农氏已经衰落，无力弹压诸侯纷争，百姓苦不堪言。轩辕便替神农氏征讨恣意妄为者，诸侯纷纷归顺。他四处巡视，东到东海，登泰山；西到空桐，登鸡头山；南到长江，登熊山、湘山；北逐荤粥部族，会盟诸侯，在逐鹿山下建起都邑。</p>",
            "rotate":null,
            "lng":null,
            "spotid":306744,
            "allimg":require("../../assets/tst/tst2-02.jpg"),
            "hotLevel":0,
            "spotname":"甫而神灵  弱而能言   从征万国  及至四方",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211119/6654a4446ee66aea40affc950ca04fdd.mp3",
            "number":1,
            "totaltime":148,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-02-1.gif"),
            "id":66015,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>炎帝欲侵陵诸侯，诸侯咸归轩辕。轩辕乃修德振兵，治五气，艺五种，抚万民，度四方，教熊、罴、貔、貅、貙[chū]、虎，以与炎帝战于阪泉之野。三战，然后得其志……——《史记·五帝本纪》</p><p><br/></p><p>轩辕广施德行，整顿军武，研究四时节气变化，教人耕种五谷，安抚百姓，成为天下敬服的统领。当时神农氏虽然势力衰落，但其首领炎帝仍欲号令天下，常常攻伐周边，诸侯们纷纷转投轩辕。轩辕率领投奔来的诸侯军队，带熊、豹、貔貅等猛兽，同炎帝在阪泉郊野进行三次大战。炎帝不敌，愿意讲和，炎黄部落便建立联盟。</p><p> </p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306745,
            "allimg":require("../../assets/tst/tst2-03.jpg"),
            "hotLevel":0,
            "spotname":"神农虽衰  炎帝欲返   阪泉于野  共族炎黄",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211119/29a9f6c0776c0e92745afc4b2bcf9708.mp3",
            "number":2,
            "totaltime":187,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-03-1.gif"),
            "id":66016,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>而蚩尤最为暴，莫能伐……蚩尤作乱，不用帝命。于是黄帝乃征师诸侯，与蚩尤战于涿鹿之野，遂禽杀蚩尤。而诸侯咸尊轩辕为天子，代神农氏，是为黄帝。天下有不顺者，黄帝从而征之，平者去之，披山通道，未尝宁居……——《史记·五帝本纪》</p><p><br/></p><p>九黎族首领蚩尤勇猛无敌，他带着多个部族联军来到轩辕炎黄部落所在的涿鹿挑衅。轩辕统领炎黄部落和诸侯联军，在涿鹿一带迎战蚩尤，经数月激战，击溃九黎联军，擒杀蚩尤。自此，九黎、三苗、东夷等部落纷纷归顺。天下诸侯便尊奉轩辕为天子，号黄帝，取代神农氏。自此进入天下一统的部落时代。</p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306746,
            "allimg":require("../../assets/tst/tst2-04.jpg"),
            "hotLevel":0,
            "spotname":"逐鹿决对  九黎归降   东夷来贺  天下初奠",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211125/a9172030825af3edd15f6a8690c8211b.mp3",
            "number":3,
            "totaltime":221,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-04-1.gif"),
            "id":66017,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>置左右大监，监于万国。万国和，而鬼神山川封禅与为多焉。获宝鼎，迎日推筴。举风后、力牧、常先、大鸿以治民。顺天地之纪，幽明之占，死生之说，存亡之难。时播百谷草木，淳化鸟兽虫蛾，旁罗日月星辰水波土石金玉，劳勤心力耳目，节用水火材物……——《史记·五帝本纪》</p><p><br/></p><p>黄帝设置左右大监之职，以督察诸侯各国事务；他任用风后、力牧、常先、大鸿等能臣帮助治理天下；他顺应天地规律，按照季节播种百谷，驯养鸟兽蚕虫，测定日月星辰，确定农耕历法，收取土石金玉以供民用，同时要求节约用水、火、木材等各种物资……在黄帝领导下，天下安定，万国和谐。</p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306747,
            "allimg":require("../../assets/tst/tst2-05.jpg"),
            "hotLevel":0,
            "spotname":"百草鸟兽  各遵明典   万国和合  顺地法天",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211122/b831bfd30e45e519c1e0d08ebaaacf4d.mp3",
            "number":4,
            "totaltime":219,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-05-1.gif"),
            "id":66043,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>黄帝二十五子，其得姓者十四人。黄帝居轩辕之丘，而娶于西陵之女，是为嫘祖……——《史记·五帝本纪》</p><p><br/></p><p>黄帝住在轩辕山下，他后来迎娶西陵蜀山氏部落酋长的女儿嫘祖为正妻。嫘祖饲养天蚕，教导人们制作衣裳，还将桑蚕技术带到中原大地。黄帝共生有二十五个儿子，大多成为各个部落的首领，其中有十四个人后来都有了自已的姓氏，传承至今，黄帝也即成为中华姓氏始祖。<br/></p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306748,
            "allimg":require("../../assets/tst/tst2-06.jpg"),
            "hotLevel":0,
            "spotname":"西陵有女  嫘祖始蚕   二十五嗣  得姓七双",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211122/872099a518c81ad37089d1702e288e00.mp3",
            "number":5,
            "totaltime":178,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-06-1.gif"),
            "id":66038,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>嫘祖为黄帝正妃，生二子，其后皆有天下：其一曰玄嚣，是为青阳，青阳降居江水；其二曰昌意，降居若水……——《史记·五帝本纪》</p><p><br/></p><p>黄帝和正妻嫘祖生有两个儿子，长子玄嚣，号青阳，次子昌意。相传黄帝百岁之时，和嫘祖同时梦到玄器降于日出东方的江水之滨，昌意居于三千里外的若水河畔。黄帝以为是天意安排，便将玄器分封到东海之滨，后来其子孙即为少昊青阳氏；将昌意分封在若木参天的西南之地，后来其子孙即为高阳氏。</p><p><br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306749,
            "allimg":require("../../assets/tst/tst2-07.jpg"),
            "hotLevel":0,
            "spotname":"东讫江水  少昊青阳   昌意梦回  若水三千",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211130/b7f6097f2d9fe7f269e927cea8c5a247.mp3",
            "number":6,
            "totaltime":143,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-07-1.gif"),
            "id":66171,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>昌意娶蜀山氏女，曰昌仆，生高阳，高阳有圣德焉。黄帝崩，葬桥山。其孙昌意之子高阳立，是为帝颛顼也。帝颛顼高阳者，黄帝之孙而昌意之子也。静渊以有谋，疏通而知事；养材以任地，载时以象天，依鬼神以制义，治气以教化，絜诚以祭祀。北至于幽陵，南至于交趾，西至于流沙，东至于蟠木……——《史记·五帝本纪》</p><p><br/></p><p>昌意到封地若水，娶蜀山氏之女昌仆为妻，生下高阳。高阳降生时，戴着戈形冠冕，冠上刻有“圣德”二字。高阳确有圣人之德，黄帝升天之时，召其从若水之地赶来继承帝位，是为颛顼帝。颛顼观测天象，制定历法，统一四边，教化万民，首开男婚女嫁，倡导祭祀神灵，进一步发展中华文明。颛顼身后留下七十余姓。</p>",
            "rotate":null,
            "lng":null,
            "spotid":306750,
            "allimg":require("../../assets/tst/tst2-08.jpg"),
            "hotLevel":0,
            "spotname":"颛顼化教  嗣位帝权   象天制义  文贤中央",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211130/535a3e3647849eb3bcb06e278be07b6c.mp3",
            "number":7,
            "totaltime":195,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-08-1.gif"),
            "id":66172,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>颛顼崩，而玄嚣之孙高辛立，是为帝喾……高辛于颛顼为族子……顺天之义，知民之急。仁而威，惠而信，修身而天下服。取地之财而节用之，抚教万民而利诲之，历日月而迎送之，明鬼神而敬事之。其色郁郁，其德嶷嶷。其动也时，其服也士。帝喾溉执中而遍天下，日月所照，风雨所至，莫不从服……——《史记·五帝本纪》</p><p><br/></p><p>高辛是玄器之孙，颛顼之侄，相传刚出生时能叫出自己的名字，众人以为天降。颛顼去世后，便把帝位传给高辛，这就是五帝之一的帝喾。帝喾仁德而威严，明法而公正，能预判事物的发展规律，体察百姓所急；他发明采矿之法，制作生产工具，天下莫不信服。帝喾身后留下六百余姓，其子契和弃（即后稷）分别成为商、周两朝的始祖。</p>",
            "rotate":null,
            "lng":null,
            "spotid":306752,
            "allimg":require("../../assets/tst/tst2-09.jpg"),
            "hotLevel":0,
            "spotname":"帝喾嶷嶷  知义顺天   族叔授立  天下归望",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211130/06ed08860b249433f7cf4225e5adce28.mp3",
            "number":8,
            "totaltime":165,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-09-1.gif"),
            "id":66173,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          },
          {
            "sub":"<p>太史公曰：</p><p>帝喾娶陈锋氏女，生放勋。娶娵訾氏女，生挚。帝喾崩，而挚代立。帝挚立，不善，而弟放勋立，是为帝尧。帝尧者，放勋。其仁如天，其知如神。就之如日，望之如云。富而不骄，贵而不舒。黄收纯衣，彤车乘白马。能明驯德，以亲九族。九族既睦，便章百姓。百姓昭明，合和万国……——《史记·五帝本纪》</p><p><br/></p><p>帝喾另有两个儿子，叫放勋和挚。帝喾死后，由挚接替其帝位。当时天下旱涝相继，挚无力应对，便将帝位让给弟弟放勋，这就是五帝之一的唐尧。尧帝继位后，招来四岳协助治理天下，征召后羿射日，共工治水，重用民间有才德之人，发明制陶工艺……致使百姓和乐，四海升平，诸侯之间亦能和睦共处。<br/></p>",
            "rotate":null,
            "lng":null,
            "spotid":306753,
            "allimg":require("../../assets/tst/tst2-10.jpg"),
            "hotLevel":0,
            "spotname":"挚袭天命  政令不善   唐尧中继  昭明万方",
            "pspotname":"太史上图",
            "url":"https://filewc.geeker.com.cn/jpjs/upload/voice/20211130/fe89bdda31798adf1ebdc790add06456.mp3",
            "number":9,
            "totaltime":266,
            "pspotid":306741,
            "logo": require("../../assets/tst/tst2-10-1.gif"),
            "id":66174,
            "state":1,
            "lat":null,
            "info":"三皇五帝源流图·中华始祖大观园"
          }
        ],
        storyInd: -1, //点开看的详情下标
        audioInd: -1, //点击的音频下标
        swiperInd:-1,//swiper滑动的下标
        playingInd: -1, //正在播放的音频下标

        mySwiper: null,
        audioCanAutoPlay: true, //音频能自动播放
      }
    },
    computed: {

    },
    mounted() {
      var self = this;
      self.$nextTick(function() {
          self.mySwiper = new Swiper("#mySwiper", {
            direction : 'vertical',
            slidesPerView: 'auto',
            freeMode: true,
            resistanceRatio : 0,
            watchOverflow: true, //当没有足够的slide切换时，例如只有1个slide（非loop），swiper会失效且隐藏导航等。默认不开启这个功能。
            loop: false,//开启循环模式
            observeParents:true,
            observer: true,
            autoplay: false,
            touchRatio: 1,                   //解决滑动卡顿
            longSwipesRatio:0.1,
//            followFinger:false,
            scrollbar: {
              el: '.swiper-scrollbar',
              hide: true
            },
            on:{
              slideChange: function(){
                self.swiperInd = this.activeIndex;
              },
              touchStart: function(){
                if(self.audioCanAutoPlay==true){
                  self.storyAudioPlay(self.audioInd);
                }
              },
            }
          });

      });
    },
    created(){
      let self = this;
//      this.$loading.show('数据加载中');
      this.id = this.$route.query.id;

      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if (this.appKey) {
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey": this.appKey});
        this.sendUserBrowse();
      } else {
        setStore("appKey", {"appKey": ""});
      }

      this.userInfo = getStore("userInfo");
      this.initData();
    },
    beforeDestroy(){},
    methods: {
      //初始化：获取研学首页数据
      async initData(){
//        let res = await getVideoPlay({
//          TimeStamp: this.TimeStamp,
//          openid: this.userInfo.openid,
//          bagid: '4491'
//        });
//        if(res.errcode == "00000"){
//          this.$loading.hide();
//          this.list = res.data.voiceList;
//        }

        let title = '中华源流•太史图 | 金牌解说';
        let desc = '金牌解说邀您参与中华历史文脉图鉴，听解说！讲故事！弘扬历史文化！';
        let link = '/story-detail';
        let img = 'https://jpjstest.geeker.com.cn/dist/static/logo.png';
        wxShareme(title,desc,img,link);
      },

      //滚动到指定的slide
      toStep: function(ind){
        this.mySwiper.slideTo(ind, 1000, false);//切换到第一个slide，速度为1秒
      },

      //点击显示某个详情
      storyDetailShow: function(ind){
        this.alertShow = 1;
        this.storyInd = ind;
      },

      //点击播放某个音频
      storyAudioPlay: function (ind){
        var AudioStory = document.getElementById('AudioStory');
        if(this.audioInd == ind){
          if (AudioStory.paused) {
            AudioStory.play();
            this.playingInd = ind;
          } else {
            AudioStory.pause();
            this.playingInd = -1;
          }
        }else {
          this.audioInd = ind;
          AudioStory.src = this.list[ind].url;
          AudioStory.preload = "auto";
          AudioStory.play();
          this.playingInd = ind;
          if(this.audioCanAutoPlay == false){
            this.storyDetailShow(ind);
          }
          this.audioCanAutoPlay = false;
        }

        var self = this;
        AudioStory.onended = function() {  //音频播放结束
          var index = (self.audioInd == self.list.length -1) ? 0 : (parseInt(self.audioInd) + 1);

          self.storyAudioPlay(index);
        };
      },

    },

    watch: {},
    components: {wxConfirm},
  }

</script>

<style scoped>
  .page{width:100vw;height:100vh;padding:0;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);overflow: hidden;-webkit-overflow-scrolling: touch;}
  .swiper-container{width: 100vw;height: 100vh;}
  .swiper-slide{ -webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}
  .swiper-slide img,.img{background: none;-webkit-transform: translate3d(0, 0, 0);transform: translate3d(0, 0, 0);}
  .swiper-container .swiper-slide{width: 100%;height: auto;}
  .swiper-container .swiper-slide .img{display: block;width: 100%;height: auto;}
  .swiper-scrollbar{opacity: 0!important;}
  .swiper-slide.full-slide{position:relative;min-width: 100vw;height: 100vh;background: #fff;}

  .slide1 .index-logo{opacity:0;position: absolute;top: 50%;left: 50%;width: 59.33vw;height: auto;-webkit-transform: translate(-50%,-50%)  rotate(90deg);transform: translate(-50%,-50%)  rotate(90deg);-webkit-animation: showAni 1.2s linear;animation: showAni 1.2s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .slide1 .tst-text{opacity:0;position: absolute;top: 50%;right: 14vw;width: 33.86vw;height: auto;-webkit-transform: translate(-24px,-50%);transform: translate(-24px,-50%);-webkit-animation: fadeR 1.2s linear;animation: fadeR 1.2s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .slide1 .footer-logo{position: absolute;top: 50%;left: 14vw;width: 19.86vw;height: auto;-webkit-transform: translateY(-50%);transform: translateY(-50%);}
  .slide2 .txt-con{position:absolute;top:50%;left:50%;width: 80vh;max-height: calc(100vw - .72rem);-webkit-transform:translate(-50%,-50%) rotate(90deg);transform:translate(-50%,-50%) rotate(90deg);color: #000;overflow-y: scroll;}
  .slide2 .tit{font-size: .30rem;}
  .slide2 .txt{margin-top:.11rem;font: .24rem/.36rem "fangsong";}
  .slide3{padding-right: .58rem;}
  .slide3 .logo{float:left;width: auto;height: 57.6vh;margin-left: .46rem;margin-top:21.2vh; }
  .slide3 .tit-img{opacity:0;float:left;width: auto;height: 55.6vh;margin-top:22.2vh;margin-left: .3rem;-webkit-transform: translateY(18px);transform: translateY(18px);-webkit-transition: all ease .3s;transition: all ease .3s;}
  .swiper-slide-active .tit-img{-webkit-animation: fadeUp .6s linear;animation: fadeUp .6s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .swiper-slide-active .tit-img.t1{-webkit-animation-delay: 0s;animation-delay: 0s;}
  .swiper-slide-active .tit-img.t2{-webkit-animation-delay: .2s;animation-delay: .2s;}
  .swiper-slide-active .tit-img.t3{-webkit-animation-delay: .4s;animation-delay: .4s;}
  .swiper-slide-active .tit-img.t4{-webkit-animation-delay: .6s;animation-delay: .6s;}
  .swiper-slide-active .tit-img.t5{-webkit-animation-delay: .8s;animation-delay:.82s;}
  .slide4{background: #8f5944!important;}
  .slide4 .title-bg{position: absolute;top: 50%;left:50%;width: auto;height: 56.66vw;-webkit-transform: translate(-50%,-50%) rotate(90deg);transform:translate(-50%,-50%) rotate(90deg);}
  .slide4 .num{position:relative;z-index:1;margin-top:27vh;font-family: fangsong;font-weight:bold;font-size:.36rem;color: #5c2510;}
  .slide4 .t1{position:relative;z-index:1;margin-top:5.6vh;text-align:center;font-family: fangsong;font-weight:bold;font-size:.26rem;color: #fff;}
  .slide4 .t2{position:relative;z-index:1;margin-top:2.8vh;text-align:center;font-family: fangsong;font-size:.18rem;color: #fff;}

  .story-btn{position: absolute;}
  .story-btn.btn1{left: 5%;bottom:64%;-webkit-transform: rotate(90deg);transform: rotate(90deg);}
  .story-btn.btn2{left: 5%;bottom:58%;-webkit-transform: rotate(90deg);transform: rotate(90deg);}
  .story-btn .t{position:relative;width: .76rem;height: .76rem;margin:0 auto;background: rgba(0,0,0,.6);border-radius: 50%;border:.014rem solid #df9f57;}
  .swiper-slide-active .story-btn .t{-webkit-animation: scaleB 2s linear infinite;animation: scaleB 2s linear infinite; }
  .story-btn .t img{position: absolute;top:50%;left:50%;width: 82%;height: auto;-webkit-transform: translate(-50%,-50%);transform: translate(-50%,-50%);}
  .story-btn .b{font-size: .2rem;margin-top: .07rem;color: #fff;text-shadow: #8c4c0c 1px 0 0, #8c4c0c 0 1px 0, #8c4c0c -1px 0 0, #8c4c0c 0 -1px 0;}

  .story-alert{position: fixed;top:50%;left: 50%;z-index: 9;width: 0;height: 92.5vw;-webkit-transform: translate(-50%,-50%) rotate(90deg);transform: translate(-50%,-50%) rotate(90deg);background: url(../../assets/tst/bg.png) no-repeat center;background-size: 100% 100%;}
  .story-alert:before,.story-alert:after{content: ''; position: absolute; width: .3rem; height: 97.5%; top: 50%;  transform: translateY(-50%); background-image: url(../../assets/tst/jz.png); background-size: 100% 100%;}
  .story-alert:before{left: .10rem;}
  .story-alert:after{right:.26rem;}
  .story-alert.curr{-webkit-animation: storyBg .8s linear;animation: storyBg .8s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}


  .story-alert .con{opacity:0;position: absolute;left:7.6%;top:12%;right:7.6%;bottom:12%;}
  .story-alert.curr .con{-webkit-animation: showAni .6s linear 1s;animation: showAni .6s linear 1s;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .story-alert .con .tit{font-size:.30rem;font-weight:bold;color: #5c2510;text-align: center;}
  .story-alert .con .txt{height: 77%;margin-top: .14rem;font:.28rem/.40rem "Microsoft YaHei"!important;color: #5c2510;overflow-y: scroll;}
  .story-alert .con .txt p{font:.28rem/.40rem "Microsoft YaHei"!important;}
  .story-alert .con img{position: absolute;right:2%;bottom: -2%;width:auto;height: 6%;}


  @-webkit-keyframes storyBg {from{width: 0;}to{width: 80vh;}}
  @keyframes storyBg {from{width: 0;}to{width: 80vh;}}
  @-webkit-keyframes showAni {from{opacity: 0;}to{opacity: 1;}}
  @keyframes showAni {from{opacity: 0;}to{opacity: 1;}}

  /*@-webkit-keyframes showAni {from{visibility:hidden;}to{visibility:visible;}}*/
  /*@keyframes showAni {from{visibility:hidden;}to{visibility:visible;}}*/
  /* 横屏提示 */
  .tip-box {position: fixed;top: 0;left: 0;z-index: 9;width: 100vw;height: 100vh;display: flex;flex-direction: column;justify-content: center;align-items: center;background-color: #8f5944;}
  .icon {display: block;width: 15%;height: auto;margin:0 auto;-webkit-transform: rotate(90deg);transform: rotate(90deg);animation: rotation infinite 1.5s ease-in-out;}
  .tip-box p {margin-top: .4rem;font-size: .36rem;font-family: fangsong;color: #fff;}

  /* 手机旋转动画 */
  @keyframes rotation {
    10% {transform: rotate(90deg);}
    50% {transform: rotate(0deg);}
    60% {transform: rotate(0deg);}
    90% {transform: rotate(90deg);}
    100% {transform: rotate(90deg);}
  }

  @-webkit-keyframes fadeR {
    from{opacity:0;-webkit-transform: translate(-24px,-50%);}to{opacity:1;-webkit-transform: translate(0,-50%);}
  }
  @keyframes fadeR {
    from{opacity:0;transform: translate(-24px,-50%);}to{opacity:1;transform: translate(0,-50%);}
  }
  @-webkit-keyframes scaleB {
    0%{-webkit-transform: scale(1);}
    25%{-webkit-transform:  scale(1.12);}
    50%{-webkit-transform:  scale(1);}
    75%{-webkit-transform:  scale(1.12);}
    100%{-webkit-transform:  scale(1);}
  }
  @keyframes scaleB {
    0%{transform: scale(1);}
    25%{transform:  scale(1.12);}
    50%{transform:  scale(1);}
    75%{transform:  scale(1.12);}
    100%{transform:  scale(1);}
  }
</style>



// WEBPACK FOOTER //
// src/page/story/story-detail.vue